import { gsap } from 'gsap';

let windowWidth = jQuery(window).width();

// Update cached window width on resize
jQuery(window).on('resize', () => {
  windowWidth = jQuery(window).width();
});

export function cursorChange() {
  if (windowWidth <= 740) return;

  const $mainElements = jQuery('[data-newcursor]');
  const $cursor = jQuery('#cursor');

  $mainElements.each((_, element) => {
    const $element = jQuery(element);
    const title = $element.data('newcursor');

    $element.on('mousemove', event => {
      updateCursorPosition(event, $cursor);
    });

    $element.on('mouseenter', () => {
      $cursor.find('span').text(title);
      $cursor.addClass('active');
    });

    $element.on('mouseleave', () => {
      $cursor.removeClass('active');
    });

    // Event handlers for links inside elements
    $element.find('a').on('mouseenter', () => {
      // $cursor.removeClass('active');
    });

    $element.find('a').on('mouseleave', () => {
      // $cursor.addClass('active');
    });
  });
}

function updateCursorPosition(event, $cursor) {
  if (windowWidth <= 740) return;

  gsap.to($cursor, {
    x: event.clientX,
    y: event.clientY,
    duration: 0.6,
    ease: 'power1.out',
  });
}
